import Navbar  from "../NavBar/NavBar.js";
import Footer from "../Home/Footer.js"
import Whatsapp from "../Home/Whatsapp.js";
import PS from "./groupe_pages/PS/PS.js"
import PS22 from "./groupe_pages/PS/PS22.js"
import PS33 from "./groupe_pages/PS/PS33.js"
import Spinner from "../Home/Spinner.js";
import { useEffect } from "react";



const ProtectionSolaire = () => {
  useEffect(() => {
    // ✅ TITLE (SEO + local + conversion)
    document.title =
      "Protection Solaire Maroc | Films, Stores & Confort Thermique – UNIK SYSTEM";

    // ✅ DESCRIPTION (CTR + mots clés + CTA)
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Solutions de protection solaire au Maroc avec UNIK SYSTEM : films solaires pour vitrage, stores intérieurs et extérieurs design. Réduisez la chaleur et améliorez le confort thermique. Devis gratuit."
    );

    // ✅ KEYWORDS
    let keywords = document.querySelector("meta[name='keywords']");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.setAttribute("name", "keywords");
      document.head.appendChild(keywords);
    }
    keywords.setAttribute(
      "content",
      "protection solaire maroc, film solaire vitrage maroc, store interieur maroc, store exterieur maroc, film anti chaleur maroc, protection thermique maison maroc, store design maroc"
    );

    // ✅ ROBOTS
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    // ✅ CANONICAL
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute(
      "href",
      "https://unik-system.com/protection-solaire-maroc"
    );

    // ✅ OPEN GRAPH (Facebook / WhatsApp)
    const setMetaProperty = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMetaProperty(
      "og:title",
      "Protection Solaire Maroc – UNIK SYSTEM"
    );
    setMetaProperty(
      "og:description",
      "Films solaires, stores design et solutions thermiques pour un confort optimal au Maroc."
    );
    setMetaProperty(
      "og:image",
      "https://unik-system.com/static/media/4Protection%20solaire%20architecturale%20UNIK%20SYSTEM%20avec%20brise-soleil%20ext%C3%A9rieur%20design%20moderne%20(5).587e1ef5bd1e4bf3569c.webp"
    );
    setMetaProperty(
      "og:url",
      "https://unik-system.com/protection-solaire-maroc"
    );
    setMetaProperty("og:type", "website");

    // ✅ TWITTER
    let twitterCard = document.querySelector("meta[name='twitter:card']");
    if (!twitterCard) {
      twitterCard = document.createElement("meta");
      twitterCard.setAttribute("name", "twitter:card");
      document.head.appendChild(twitterCard);
    }
    twitterCard.setAttribute("content", "summary_large_image");

    let twitterImage = document.querySelector("meta[name='twitter:image']");
    if (!twitterImage) {
      twitterImage = document.createElement("meta");
      twitterImage.setAttribute("name", "twitter:image");
      document.head.appendChild(twitterImage);
    }
    twitterImage.setAttribute(
      "content",
      "https://unik-system.com/static/media/4Protection%20solaire%20architecturale%20UNIK%20SYSTEM%20avec%20brise-soleil%20ext%C3%A9rieur%20design%20moderne%20(5).587e1ef5bd1e4bf3569c.webp"
    );

  }, []);


    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <PS/>
            <PS22/>
            <PS33/>
            <Footer/>
        </div>    
    )
};

export default ProtectionSolaire;